module.exports = __webpack_public_path__ + "img/certificate3.739045ef.png";